"use client";
import { usePathname, useRouter } from "next/navigation";
import React, { useState, createContext, useMemo } from "react";

export interface PublicContextType {}

const PublicContext = createContext<PublicContextType | null>(null);
function PublicProvider({ children }: { children: JSX.Element }) {
  // HOOKS

  return (
    <PublicContext.Provider value={null}>{children}</PublicContext.Provider>
  );
}

export { PublicProvider, PublicContext };
